import * as React from 'react'
import { IPaymentSourceResponseDTO } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import ContextMenu from '../../ui/ContextMenu'
import moment from 'moment'
import classNames from 'classnames'

export interface IPaymentSourceItemProps {
  paymentSource: IPaymentSourceResponseDTO
  remove: (paymentSource: IPaymentSourceResponseDTO) => void
  makeDefault: (paymentSource: IPaymentSourceResponseDTO) => void
}

class PaymentSourceItem extends React.Component<IPaymentSourceItemProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { paymentSource } = this.props

    const PAYMENT_CONFIG = {
      EXPIRY_WARNING_MONTHS: 2
    } as const

    const cardExpiry = moment(`${paymentSource.exp_year}-${paymentSource.exp_month}-`).endOf('month')
    const allowance = moment().add(PAYMENT_CONFIG.EXPIRY_WARNING_MONTHS, 'months')
    const expired = cardExpiry < moment()
    const classes = classNames('payment-source-item', {
      ' default': paymentSource.isDefault && !expired,
      ' secondary': !paymentSource.isDefault && !expired,
      ' expired': expired
    })
    return (
      <div className={classes}>
        <div className='mb1'>
          {/* TODO: Add a proper rendering to credit cards' icon */}
          <span className={paymentSource.isDefault ? 'bold font-grey2 h5' : 'font-grey3 h5'}>
            {paymentSource.isDefault ? 'Primary' : 'Secondary'}
          </span>{' '}
          &nbsp;
          <br />
          <br />
          <span className={paymentSource.isDefault ? 'bold font-grey2 h5' : 'font-grey3 h5'}>
            {paymentSource.name}
          </span>{' '}
          &nbsp;
          {cardExpiry <= allowance && cardExpiry >= moment() && (
            <span className='bold font-red'>{`${UIMessages.rider.payment.nearingExpiry} ${cardExpiry.fromNow()}`}</span>
          )}
          {expired && <span className='bold font-red'>{`${UIMessages.rider.payment.expired}`}</span>}
          &nbsp;
          <br />
        </div>
        <div className='flex'>
          <div className='CCNumber font-grey3 h5'>**** **** **** {paymentSource.last4}</div>
          <div style={{ flex: 1 }}>&nbsp;</div>
          <div className='ml3 font-grey3 h5'>
            {`Exp Date: ${paymentSource.exp_month
              .toString()
              .padStart(2, '0')}/${paymentSource.exp_year.toString().substring(2)}`}
          </div>
          <div style={{ flex: 1 }}>&nbsp;</div>
          <ContextMenu>
            <div className='MenuItem flex cursor--pointer' onClick={this.makeDefault}>
              <span className='font-dark-grey'>{UIMessages.rider.payment.makeDefault}</span>
            </div>
            <div className='MenuItem flex cursor--pointer' onClick={this.remove}>
              <span className='font-dark-grey'>{UIMessages.common.deleteLabel}</span>
            </div>
          </ContextMenu>
        </div>
      </div>
    )
  }

  private makeDefault = () => {
    this.props.makeDefault(this.props.paymentSource)
  }

  private remove = () => {
    this.props.remove(this.props.paymentSource)
  }
}

export default PaymentSourceItem



// WEBPACK FOOTER //
// ./src/components/riders/common/PaymentSourceItem.tsx